import React, { Fragment } from 'react'
import { Col, Container, Row } from 'reactstrap';
import DataComplaintsAndClaims from './components/DataComplaintsAndClaims';

const ComplaintsAndClaims = () => {
    return (
        <Fragment>
            <Container className="dashboard">
                <Row>
                    <Col md={12}>
                        <h3 style={{ marginBottom: 15 }}>Quejas y Reclamos</h3>
                    </Col>
                </Row>
                <Row>
                    <DataComplaintsAndClaims />
                </Row>
            </Container>
        </Fragment>
    )
}

export default ComplaintsAndClaims;